import React from 'react';

export interface ProjectAccessInfo {
  isAdmin: boolean;
  isOrgAdmin: boolean;
  isDesignLicenseOnly?: boolean;
}

interface ProjectAccessContextValue {
  projectAccess: ProjectAccessInfo | undefined;
  setProjectAccess: (access: ProjectAccessInfo | undefined) => void;
}

const ProjectAccessContext = React.createContext<ProjectAccessContextValue>({
  projectAccess: undefined,
  setProjectAccess: () => undefined,
});

export const ProjectAccessProvider = ({ children }: { children: React.ReactNode }) => {
  const [projectAccess, setProjectAccess] = React.useState<ProjectAccessInfo | undefined>(
    undefined,
  );
  const value = React.useMemo(() => ({ projectAccess, setProjectAccess }), [projectAccess]);
  return <ProjectAccessContext.Provider value={value}>{children}</ProjectAccessContext.Provider>;
};

export const useProjectAccess = () => React.useContext(ProjectAccessContext);
